import React from 'react';

import { Header } from "../components/componentHeader/Header";
import { CartRecent } from '../components/ComponentCartBy/CartRecent'
import { Infoview } from "../components/componentBody/Infoview";
import { Video } from "../components/componentVideo/Video";
import { Audio } from "../components/componentAudio/Audio";
import { Table } from "../components/componentTable/Table";
import { Contact } from "../components/componentContat/Contact";
import { Footer } from "../components/componentFooter/Footer";
export function Recent() {

  return (
    <>
        <Header/>
        <CartRecent/>
        <Infoview />
        <Video />
        <Audio />
        <Table />
        <Contact />
        <Footer />
    </>
  );

}
